import React from "react";
import styled, { css } from "styled-components";
import constants from "./constants";
import TableRow from "./table_row";

const TableBody = styled.tbody`
  ${TableRow} {
    ${({ uiKitConfiguration }) => {
      return css`
        border-bottom: 1px solid
          ${uiKitConfiguration && uiKitConfiguration.colors["color-gray-300"]};

        &:hover {
          background-color: ${uiKitConfiguration &&
          uiKitConfiguration.colors["color-primary-100"]};
        }
      `;
    }};

    &:last-child {
      border-bottom: none;
    }
  }
`;

export default TableBody;
